'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _creditcards = require('creditcards');

var _utils = require('utils');

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paymentMethod = function paymentMethod(value, previousValue, allValues) {
  return allValues.paymentMethod === 'cc' ? value : '';
};
var limit = function limit(l) {
  return function (v) {
    return v && v.substr(0, l);
  };
};
var numeric = function numeric(v) {
  return v && v.replace(/[^\d]/g, '');
};
var expiryFormat = function expiryFormat(v) {
  return v && v.length > 2 ? v.slice(0, 2) + ' / ' + v.slice(2) : v;
};
var nullIfEmpty = function nullIfEmpty(v) {
  return v || null;
};

exports.default = {
  checkout: { // form name
    cardNumber: _ramda2.default.compose(nullIfEmpty, _creditcards.card.format, limit(16), _creditcards.card.parse, paymentMethod),
    cardCvc: _ramda2.default.compose(nullIfEmpty, limit(4), numeric, paymentMethod),
    cardExpiry: _ramda2.default.compose(nullIfEmpty, expiryFormat, limit(4), numeric, paymentMethod),

    vatNo: function vatNo(value, previousValue, allValues) {
      return (0, _utils.isEUCountry)(allValues.country) ? value : null;
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/formNormalization.js
// module id = 2158
// module chunks = 0